import React, { Component } from "react";
import Select from "react-select";
import { SkyLightStateless } from 'react-skylight';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";

import axios from 'axios';
import {
  ROOT_URL, //https://abc-scm.truckxi.com/api/
} from '../../../actions/root_url';

// PUT--------    {{url}}v1/oversea-warehouse/change_location/37?location=222

export const verifyRefNumber = (refNum, success) => {
  axios({
    method: 'GET',
    url: `${ROOT_URL}v1/product/check_refno_isexist?refno=${refNum}`,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
  })
    .then(res => {
      success(res.data);
      // success();
    }, err => {
      // alert(err.statusText);
    })
}


const modalStyle = {
  width: '300px',
  height: '180px',
  marginLeft: '-10%'
}

const propTypes = {
  selectedRows: PropTypes.array,
  onSuccess: PropTypes.func,
}

const defaultProps = {
  onSuccess: () => { },
  selectedRows: [],
}

class RefNumberVerify extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVerifying: true,
      refNumHasBeenUsed: false,
    };
  }

  componentDidMount() {
    this.handleRefNumberVerify();
  }

  handleRefNumberVerify = () => {
    const success = (refNumHasBeenUsed) => {
      this.setState({
        refNumHasBeenUsed,
        isVerifying: false,
      })
    }
    verifyRefNumber(this.props.RefNum, success)
  }

  renderContent = () => {
    if (this.state.isVerifying) {
      return <h4>Verifying...</h4>
    }
    if (this.state.refNumHasBeenUsed) {
      return <h4>Ref# Exist, Continue?</h4>
    }
    return <h4>Ref# NOT Exist, Continue?</h4>
  }

  render() {
    return (
      <div style={{ width: '100%', height: '100%', padding: '10px', textAlign: 'center', alignContent: 'center' }}>
        {
          this.renderContent()
        }
        <br />
        <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            // disabled={selectedRows.length !== 1}
            onClick={() => {
              this.props.onCancel();
            }}
          >
            <Translate value="cancel" />
          </Button>
          <Button
            bsStyle="warning"
            className="print-btn"
            type="button"
            onClick={() => {
              this.props.onConfirm();
            }}
          >
            <Translate value="confirm" />
          </Button>
        </div>
      </div>
    )
  }
}

const RefNumberVerifyModal = ({ onCancel, isVisible, onConfirm, title, RefNum }) => (
  <SkyLightStateless
    title={title}
    onCloseClicked={onCancel}
    dialogStyles={modalStyle}
    isVisible={isVisible}
  >
    <RefNumberVerify onConfirm={onConfirm} isVisible={isVisible} RefNum={RefNum} onCancel={onCancel}/>
  </SkyLightStateless>
)

export default RefNumberVerifyModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Products/components/RefNumberVerifyModal.jsx